import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useIntl } from 'react-intl';

import { css } from '@sorare/css';

import { CardMeta } from '#src/components/card/CardMeta/index.tsx';

import type { RewardCardPlaceholder_anyCardInterface } from './__generated__/index.graphql.ts';

const root = css`
  position: relative;
  height: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  margin-inline: auto;
`;

type Props = {
  card: RewardCardPlaceholder_anyCardInterface;
};

export const RewardCardPlaceholder = ({ card }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={root}
      role="img"
      aria-label={formatMessage({ defaultMessage: 'Loading card…' })}
    >
      <CardMeta card={card} avatarUrl={card.anyPlayer.avatarPictureUrl} />
    </div>
  );
};

RewardCardPlaceholder.fragments = {
  anyCardInterface: gql`
    fragment RewardCardPlaceholder_anyCardInterface on AnyCardInterface {
      slug
      anyPlayer {
        slug
        avatarPictureUrl
      }
      ...CardMeta_AnyCardInterface
    }
    ${CardMeta.fragments.AnyCardInterface}
  ` as TypedDocumentNode<RewardCardPlaceholder_anyCardInterface>,
};
